import { api } from '../api/client';
import type { AuthTokens, AvailableContext, SessionContext, SessionUser } from './types';

export interface LoginResult extends AuthTokens {
  user: SessionUser;
}

export const sessionApi = {
  /**
   * `partnerSlug` é a marca do hostname: a API usa para o bloqueio de
   * ambiente (conta de uma marca entrando no domínio de outra) e para a
   * whitelist de CPF. Na Eva (`default`) vai vazio, como no mobile.
   */
  login(email: string, password: string, partnerSlug?: string | null): Promise<LoginResult> {
    return api.post<LoginResult>('/api/auth/login', { email, password, partnerSlug: partnerSlug || undefined });
  },

  me(): Promise<{ user: SessionUser }> {
    return api.get<{ user: SessionUser }>('/api/auth/me');
  },

  listContexts(): Promise<{ contexts: AvailableContext[] }> {
    return api.get<{ contexts: AvailableContext[] }>('/api/auth/contexts');
  },

  switchContext(alvo: Pick<AvailableContext, 'brandId' | 'role'> & Partial<AvailableContext>): Promise<{ context: SessionContext } & AuthTokens> {
    return api.post('/api/auth/switch-context', {
      brandId: alvo.brandId,
      role: alvo.role,
      companyId: alvo.companyId ?? undefined,
      medicalProviderId: alvo.medicalProviderId ?? undefined,
    });
  },

  listAdminContexts(): Promise<{ contexts: AvailableContext[] }> {
    return api.get('/api/auth/admin-contexts');
  },

  switchAdminContext(alvo: Pick<AvailableContext, 'brandId' | 'role'>): Promise<{ context: SessionContext } & AuthTokens> {
    return api.post('/api/auth/switch-admin-context', { brandId: alvo.brandId, role: alvo.role });
  },

  logout(refreshToken: string | null): Promise<void> {
    return api.post<void>('/api/auth/logout', { refreshToken }).catch(() => undefined);
  },

  /** `partnerSlug` é a porta: é a marca dela que assina o e-mail com o código. */
  forgotPassword(email: string, partnerSlug?: string | null): Promise<void> {
    return api.post<void>('/api/auth/forgot-password', { email, partnerSlug: partnerSlug || undefined });
  },

  resetPassword(email: string, code: string, newPassword: string): Promise<void> {
    return api.post<void>('/api/auth/reset-password', { email, code, newPassword });
  },
};
